import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MessageService } from '@shared/message/message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-query-param-message',
  template: `
    <rav-message id="query-param-message"></rav-message>
  `
})
export class QueryParamMessageComponent implements OnInit, OnDestroy {
  private routeParams: Subscription;

  constructor(private activatedRoute: ActivatedRoute, public message: MessageService) {}

  ngOnInit() {
    setTimeout(() => {
      this.routeParams = this.activatedRoute.queryParamMap.subscribe((params: Params) => {
        if (!params.get('message')) return;
        this.message.show('query-param-message', { message: params.get('message'), type: params.get('type') });
      });
    }, 0);
  }

  ngOnDestroy() {
    if (this.routeParams) this.routeParams.unsubscribe();
  }
}
